import { render, staticRenderFns } from "./PostViewer.vue?vue&type=template&id=17ba2214"
import script from "./PostViewer.vue?vue&type=script&lang=js"
export * from "./PostViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports